module.exports = function () {
    if (typeof Promise !== 'undefined'){
        return Promise; // eslint-disable-line
    }
    return require('promise-polyfill');
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-web/src/$$promise.js
// module id = 1062
// module chunks = 0